import React, { useEffect, useState } from "react";
import BtnSave from "../../Components/Commons/Buttons/BtnSave";
import { Form } from "react-bootstrap";
import BtnEdit from "../Commons/Buttons/BtnEdit";
import "./Diagnosis.css";
import TextArea from "../Commons/Forms/TextArea";
import DateTimeField from "../Commons/Forms/DateTimeField";
import SelectField from "../Commons/Forms/SelectField";
import BtnDelete from "../Commons/Buttons/BtnDelete";
// import {
//   createDiagnostic,
//   getDiagnostic,
//   updateDiagnostic,
// } from "../../Helpers/Apis/Checkup/DiagnosticsApi"
import { ToastContainer, toast } from "react-toastify";
import {
  createDiagnostic,
  getDiagnostic,
  updateDiagnostic,
} from "../Helpers/API/CheckUpApi/CheckUpApi";

function DiagnosisVer2(props) {
  const [addDetails, setAddDetails] = useState([{}]);
  const [details, setDetails] = useState({});
  const [isClicked, setIsClicked] = useState(false);
  const [minDate, setMinDate] = useState("");
  const [action, setAction] = useState("add");

  useEffect(() => {
    // Function to get the current date and time in the required format
    const getCurrentDateTime = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    setMinDate(getCurrentDateTime());
  }, []);
  const laboratory = [
    { name: "lab_name", lab_index: -1, value: "", label: "Select" },
    {
      name: "lab_name",
      lab_index: 0,
      value: "urine_metanephrines",
      label: "Urine Metanephrines",
    },
    { name: "lab_name", lab_index: 1, value: "gm_ogtt", label: "75 gm OGTT" },
    {
      name: "lab_name",
      lab_index: 2,
      value: "serum_cortisol",
      label: "8 am Serum Cortisol",
    },
    { name: "lab_name", lab_index: 3, value: "albumin", label: "Albumin" },
    {
      name: "lab_name",
      lab_index: 4,
      value: "alkaline_phosphatase",
      label: "Alkaline Phosphatase",
    },
    { name: "lab_name", lab_index: 5, value: "amylase", label: "Amylase" },
    {
      name: "lab_name",
      lab_index: 6,
      value: "anti_thyroglobulin",
      label: "Anti-thyroglobulin",
    },
    {
      name: "lab_name",
      lab_index: 7,
      value: "basic_check_up_labs",
      label: "Basic Check Up Labs",
    },
    {
      name: "lab_name",
      lab_index: 8,
      value: "blood_type",
      label: "Blood Type",
    },
    { name: "lab_name", lab_index: 9, value: "bua", label: "BUA" },
    { name: "lab_name", lab_index: 10, value: "bun", label: "BUN" },
    { name: "lab_name", lab_index: 11, value: "cbc", label: "CBC" },
    {
      name: "lab_name",
      lab_index: 12,
      value: "creatinine",
      label: "Creatinine",
    },
    { name: "lab_name", lab_index: 13, value: "egfr", label: "eGFR" },
    { name: "lab_name", lab_index: 14, value: "fbs", label: "FBS" },
    { name: "lab_name", lab_index: 15, value: "fsh", label: "FSH" },
    { name: "lab_name", lab_index: 16, value: "ft3", label: "FT3" },
    { name: "lab_name", lab_index: 17, value: "ft4", label: "FT4" },
    { name: "lab_name", lab_index: 18, value: "hba1c", label: "HbA1c" },
    { name: "lab_name", lab_index: 19, value: "hbsag", label: "HBsAg" },
    { name: "lab_name", lab_index: 20, value: "hiv", label: "HIV" },
    { name: "lab_name", lab_index: 21, value: "igf_1", label: "IGF-1" },
    {
      name: "lab_name",
      lab_index: 22,
      value: "indirect_bilirubin",
      label: "Indirect Bilirubin",
    },
    {
      name: "lab_name",
      lab_index: 23,
      value: "intact_ph",
      label: "Intact PTH",
    },
    {
      name: "lab_name",
      lab_index: 24,
      value: "ionized_calcium",
      label: "Ionized Calcium",
    },
    {
      name: "lab_name",
      lab_index: 25,
      value: "lipid_profile",
      label: "Lipid Profile",
    },
    { name: "lab_name", lab_index: 26, value: "magnesium", label: "Magnesium" },
    {
      name: "lab_name",
      lab_index: 27,
      value: "micral_test",
      label: "Micral Test",
    },
    { name: "lab_name", lab_index: 28, value: "pap_smear", label: "Pap Smear" },
    {
      name: "lab_name",
      lab_index: 29,
      value: "phosphorus",
      label: "Phosphorus",
    },
    {
      name: "lab_name",
      lab_index: 30,
      value: "plasma_insulin",
      label: "Plasma Insulin",
    },
    {
      name: "lab_name",
      lab_index: 31,
      value: "Plasma_renin_activity",
      label: "Plasma Renin Activity",
    },
    { name: "lab_name", lab_index: 32, value: "potassium", label: "Potassium" },
    { name: "lab_name", lab_index: 33, value: "rbs", label: "RBS" },
    {
      name: "lab_name",
      lab_index: 34,
      value: "sars_cov_antigen_swab",
      label: "SARS COV2 Antigen Swab",
    },
    {
      name: "lab_name",
      lab_index: 35,
      value: "sars_cov2_clia",
      label: "SARS COV2 Clia",
    },
    {
      name: "lab_name",
      lab_index: 36,
      value: "sars_cov2_rt_pcr",
      label: "SARS COV2 RT PCR",
    },
    {
      name: "lab_name",
      lab_index: 37,
      value: "serum_aldosterone",
      label: "Serum Aldosterone",
    },
    {
      name: "lab_name",
      lab_index: 38,
      value: "serum_estradiol",
      label: "SERUM ESTRADIOL",
    },
    { name: "lab_name", lab_index: 39, value: "serum_fsh", label: "SERUM FSH" },
    {
      name: "lab_name",
      lab_index: 40,
      value: "serum_prolactin",
      label: "SERUM PROLACTIN",
    },
    { name: "lab_name", lab_index: 41, value: "sgot", label: "SGOT" },
    { name: "lab_name", lab_index: 42, value: "sgpt", label: "SGPT" },
    { name: "lab_name", lab_index: 43, value: "sodium", label: "Sodium" },
    {
      name: "lab_name",
      lab_index: 44,
      value: "stool_exam",
      label: "Stool Exam",
    },
    { name: "lab_name", lab_index: 45, value: "t3", label: "T3" },
    { name: "lab_name", lab_index: 46, value: "t4", label: "t4" },
    {
      name: "lab_name",
      lab_index: 47,
      value: "thyroglobulin",
      label: "Thyroglobulin",
    },
    {
      name: "lab_name",
      lab_index: 48,
      value: "total_bilirubin",
      label: "Total Bilirubin",
    },
    {
      name: "lab_name",
      lab_index: 49,
      value: "total_calcium",
      label: "Total Calcium",
    },
    { name: "lab_name", lab_index: 50, value: "tsh", label: "TSH" },
    {
      name: "lab_name",
      lab_index: 51,
      value: "urinalysis",
      label: "Urinalysis",
    },
    {
      name: "lab_name",
      lab_index: 52,
      value: "urine_culture_sensitivity",
      label: "Urine Culture and Sensitivity",
    },
    {
      name: "lab_name",
      lab_index: 53,
      value: "urine_ketones",
      label: "Urine Ketones",
    },
    { name: "lab_name", lab_index: 54, value: "vdrl_tpha", label: "VDRL/TPHA" },
  ];

  const specialTest = [
    { name: "lab_name", value: "", label: "Select" },
    {
      name: "lab_name",
      value: "24-urine Metanephrines",
      label: "24-urine Metanephrines",
    },
    {
      name: "lab_name",
      value: "8 am Serum Cortisol",
      label: "8 am Serum Cortisol",
    },
    {
      name: "lab_name",
      value: "Anti-thyroglobulin",
      label: "Anti-thyroglobulin",
    },
    {
      name: "lab_name",
      value: "Basic Checkup Labs",
      label: "Basic Checkup Labs",
    },
    { name: "lab_name", value: "IGF-1", label: "IGF-1" },
    { name: "lab_name", value: "Intact PTH", label: "Intact PTH" },
    { name: "lab_name", value: "Plasma Insulin", label: "Plasma Insulin" },
    {
      name: "lab_name",
      value: "Plasma Renin Activity",
      label: "Plasma Renin Activity",
    },
    {
      name: "lab_name",
      value: "Serum Aldosterone",
      label: "Serum Aldosterone",
    },
    { name: "lab_name", value: "Thyroglobulin", label: "Thyroglobulin" },
  ];

  const radiology = [
    { name: "lab_name", value: "", label: "Select" },
    { name: "lab_name", value: "12-L ECG", label: "12-L ECG" },
    {
      name: "lab_name",
      value: "2D ECHO WITH DOPPLER",
      label: "2D ECHO WITH DOPPLER",
    },
    {
      name: "lab_name",
      value: "Breast Ultrasound",
      label: "Breast Ultrasound",
    },
    {
      name: "lab_name",
      value: "Chest X-Ray Lateral View",
      label: "Chest X-Ray Lateral View",
    },
    {
      name: "lab_name",
      value: "Chest X-Ray PA View",
      label: "Chest X-Ray PA View",
    },
    { name: "lab_name", value: "Mammogram", label: "Mammogram" },
    {
      name: "lab_name",
      value: "Mammogram and Breast Ultrasound",
      label: "Mammogram and Breast Ultrasound",
    },
    {
      name: "lab_name",
      value: "Pelvic Ultrasound",
      label: "Pelvic Ultrasound",
    },
    {
      name: "lab_name",
      value: "Pelvic Ultrasound-TVS",
      label: "Pelvic Ultrasound-TVS",
    },
  ];

  const handleAddChange = (e, index, search) => {
    if (search) {
      const { name, label } = e;
      var details = [...addDetails];
      addDetails[index][name] = label;
      addDetails[index][name] = label;
      addDetails[index]["selected"] = {
        label: label,
        value: label,
      };
      setAddDetails(details);
    } else {
      const { name, value } = e.target;
      if (name === "fasting" || name === "notes") {
        setDetails((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        const { name, value } = e.target;
        var details = [...addDetails];
        addDetails[index][name] = value;
        setAddDetails(details);
      }
    }
  };

  function handleAddNewRow() {
    const newRow = { generic: "" };
    setAddDetails((prevRow) => [...prevRow, newRow]);
  }

  function handleDeleteRow(index) {
    const newList = [...addDetails];
    newList.splice(index, 1);
    setAddDetails(newList);
  }

  async function handleSaveDiagnostic() {
    if (action === "add") {
      const response = await createDiagnostic(
        details,
        addDetails,
        props.id,
        props.assessmentId
      );

      setIsClicked(true);
      if (response.data) {
        toast.success("Successfully Added Details!", { autoClose: 1000 });
        setTimeout(() => {
          fetchData(response.data.diagnostic_id);
          props.setDiagnosticId(response.data.assessment_id);
          setIsClicked(false);
          props.nextTab("therapeutics");
        }, 1000);
      } else {
        response.error?.data?.messages?.error_messages.map((data) => {
          return toast.error(data);
        });
        // toast.error("Something went wrong");
        setIsClicked(false);
      }
    } else {
      const response = await updateDiagnostic(
        details,
        addDetails,
        props.id,
        props.assessmentId
      );
      setIsClicked(true);
      if (response.data) {
        toast.success("Successfully Updated Details!", { autoClose: 1000 });
        setTimeout(() => {
          fetchData(response.data.diagnostic_id);
          setIsClicked(false);
        }, 1000);
      } else {
        response.error?.data?.messages?.error_messages.map((data) => {
          return toast.error(data);
        });
        // toast.error("Something went wrong");
        setIsClicked(false);
      }
    }
  }

  async function fetchData(diagnostic_id) {
    const response = await getDiagnostic(diagnostic_id);
    if (response.error) {
      setAddDetails([]);
    } else {
      setAction("edit");
      setAddDetails(response.data[0].diagnostic_items);
      setDetails(response.data[0]);

      props.setDiagnosticItems(response.data[0].diagnostic_items);
      props.setDiagnostics(response.data[0]);
    }
  }

  return (
    <div className="App">
      {/* <ToastContainer /> */}
      <div className=" col pt-4">
        <div className="">
          <div className="row mt-2">
            <div className="col-sm-12">
              <label className="col-6 font-bold font-large mb-2">
                DIAGNOSTICS
              </label>
              <div className="col therapeutics-prescription-form-cont">
                <div className="row pl-4 pt-2">
                  <div className="col-3">
                    <label className="font-bold mb-2">Type</label>
                    <span className="badge">*</span>
                  </div>
                  <div className="col-3">
                    <label className="font-bold mb-2">Name</label>
                    <span className="badge">*</span>
                  </div>
                  <div className="col-3">
                    <label className="font-bold mb-2">Schedule</label>
                    <span className="badge">*</span>
                  </div>
                </div>
                {addDetails.map((data, index) => {
                  return (
                    <>
                      <div className="row pl-4 pt-1">
                        <div className="col mt-2">
                          <SelectField
                            // required
                            // formLabel={`Type`}
                            name="type"
                            size={`sm`}
                            options={[
                              { value: "Select", label: "Select" },
                              { value: "Laboratory", label: "Laboratory" },
                              { value: "Special Test", label: "Special Test" },
                              { value: "Radiology", label: "Radiology" },
                            ]}
                            onChange={(e) => handleAddChange(e, index)}
                            value={data.type}
                          />
                        </div>
                        <div className="col">
                          <SelectField
                            searchable
                            // required
                            // formLabel={`Laboratory`}
                            name="lab_name"
                            size={`sm`}
                            options={
                              data.type !== undefined
                                ? data.type === "Laboratory"
                                  ? laboratory
                                  : data.type === "Special Test"
                                  ? specialTest
                                  : radiology
                                : []
                            }
                            onChange={(e) => handleAddChange(e, index, true)}
                            value={data.selected}
                          />
                        </div>
                        <div className="col mt-2">
                          <DateTimeField
                            min={minDate}
                            className="bigger-field"
                            // required
                            id="lab_schedule"
                            name="lab_schedule"
                            // formLabel={`Schedule`}
                            size={`sm`}
                            onChange={(e) => handleAddChange(e, index)}
                            value={data.lab_schedule}
                          />
                        </div>
                        <div className="col-2 mt-2 left">
                          <BtnDelete
                            label={"Delete"}
                            size={"sm"}
                            onClick={() => handleDeleteRow(index)}
                          />
                        </div>
                      </div>
                    </>
                  );
                })}
                <div className="row pl-4 pt-2">
                  <div className="col-2">
                    <BtnEdit
                      label={"Add"}
                      size={"sm"}
                      onClick={handleAddNewRow}
                    />
                  </div>
                  <div className="col-sm-4"></div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="row mt-3">
                  <label className="col-6 font-bold mb-2">Fasting</label>
                  <div className="row">
                    <div className="col-sm-3">
                      <Form.Check
                        type="radio"
                        label="Fasting 8 Hours"
                        id="Fasting 8 Hours"
                        name="fasting"
                        value="8 hrs"
                        className="pt-2"
                        defaultChecked={details.fasting === "8 hrs"}
                        onChange={(e) => handleAddChange(e)}
                      />
                    </div>
                    <div className="col-sm-3">
                      <Form.Check
                        type="radio"
                        label="Fasting 8-10 Hours"
                        id="Fasting 8-10 Hours"
                        name="fasting"
                        value="8-10 hrs"
                        className="pt-2"
                        defaultChecked={details.fasting === "8-10 hrs"}
                        onChange={(e) => handleAddChange(e)}
                      />
                    </div>
                    <div className="col-sm-3">
                      <Form.Check
                        type="radio"
                        label="Fasting 10-12 hrs"
                        id="Fasting 10-12 hrs"
                        name="fasting"
                        value="10-12 hrs"
                        className="pt-2"
                        defaultChecked={details.fasting === "10-12 hrs"}
                        onChange={(e) => handleAddChange(e)}
                      />
                    </div>
                    <div className="col-sm-3">
                      <Form.Check
                        type="radio"
                        label="No Fasting Needed"
                        id="No Fasting Needed"
                        name="fasting"
                        value="none"
                        className="pt-2"
                        defaultChecked={details.fasting === "none"}
                        onChange={(e) => handleAddChange(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-12">
                    <TextArea
                      // required
                      id="notes"
                      name="notes"
                      formLabel={`Notes`}
                      size={`sm`}
                      onChange={(e) => handleAddChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-end mt-2 mb-3">
          {/* {
                        hasVitalSigns && (
                            <div className="col-2">
                                <BtnEdit label={"EDIT"} size={"sm"} />
                            </div>
                        )
                    } */}
          <div className="col-2">
            <BtnSave
              label={"Submit"}
              size={"sm"}
              isClicked={isClicked}
              onClick={() => handleSaveDiagnostic()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiagnosisVer2;
